/**
 * 根据当前页面域名，动态返回对应的 API 地址
 * 只需打一次包，部署到不同域名自动匹配对应环境 API
 */
const hostname = window.location.hostname

const API_MAP = {
  // 以下根据实际情况修改域名映射
  'help.tayu123.com': 'http://api.ttayu123.com',       // 测试环境
  'localhost':       'http://api.ttayu123.com',       // 本地开发
  'help.tymsyl.com':       'https://api.tymsyl.com',          // 正式环境
  'bixun.tanmoxx.com':   'https://api.ttayu.com',          // 正式环境(www)
}

const BASE_API = API_MAP[hostname] || 'https://api.ttayu.com' // 默认正式

export default BASE_API



// WEBPACK FOOTER //
// ./src/utils/api.js